import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=20f64d58&scoped=true"
import script from "./EmailVerification.vue?vue&type=script&lang=ts"
export * from "./EmailVerification.vue?vue&type=script&lang=ts"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=20f64d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f64d58",
  null
  
)

export default component.exports